import Vue from 'vue';
import Vuex, { Store } from 'vuex';

import AuthenticationModule from './authentication.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    authentication: AuthenticationModule,
  },
}) as Store<any>;
